import { Box, Typography, Tooltip } from "@mui/material";
import { colors as muiColors } from "@mui/material";
import { styles } from "./styles";

const ResultBox = ({ compliedResults, sx }) => {
  const tooltipTitle = (
    <Box>
      <Typography variant="body2">
        Passed: {compliedResults?.passed ?? "-"}
      </Typography>
      <Typography variant="body2">
        Failed: {compliedResults?.failed ?? "-"}
      </Typography>
      <Typography variant="body2">
        Skipped: {compliedResults?.skipped ?? "-"}
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Box sx={sx || styles.resultStack}>
        <Typography
          textAlign={"right"}
          variant="h5"
          color={muiColors.green[400]}
        >
          {compliedResults?.passed ?? "-"}
        </Typography>
        /
        <Typography textAlign={"right"} variant="h5" color={muiColors.red[300]}>
          {compliedResults?.failed ?? "-"}
        </Typography>
        /
        <Typography textAlign={"right"} variant="h5">
          {compliedResults?.skipped ?? "-"}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default ResultBox;
